import { Box, Chip, Typography } from '@mui/material';
import React from 'react';

import Icon from '@components/Icon/Icon';
import StackedIcon from '@components/Icon/StackedIcon';

import { getObservationConfig } from '@constants/fhir';

import { useHealthChart } from '@hooks/useHealthChart';
import { useIsMobile } from '@hooks/useIsMobile';
import useReferenceRange from '@hooks/useReferenceRange';

import { FontWeight } from '../../../../../../theme/typography';

// const messages = defineMessages({
//   normalRange: {
//     id: 'healthTracker.detail.header.normalRange',
//     defaultMessage: 'Normal Range:',
//   },
// });

interface NormalRangeChipProps {
  onClick: () => void;
}

export default function NormalRangeChip({
  onClick: handleClick,
}: NormalRangeChipProps) {
  const isMobile = useIsMobile();
  const { code, normalRange: norm } = useHealthChart();
  const { displayFriendlyRange } = useReferenceRange();
  const signData = getObservationConfig(code);

  const icon = signData?.icon;

  const normalRange = norm
    ? displayFriendlyRange({
        code,
        parameters: norm.parameters,
        include_clusivity: !isMobile,
      })
    : undefined;

  return normalRange ? (
    <Chip
      clickable
      // color="success"
      deleteIcon={
        <Icon
          color="success.dark"
          name="circle-question"
          size="lg"
          type="far"
        />
      }
      icon={
        <StackedIcon
          icons={(icon ?? []).map((i) => ({
            key: i.name,
            size: 'xl',
            type: 'fas',
            ...i,
            color: 'success.main',
          }))}
        />
      }
      label={
        <Typography
          color="success.dark"
          variant="caption"
          sx={{ fontWeight: FontWeight.Bold }}
        >
          {normalRange}
        </Typography>
      }
      onClick={handleClick}
      onDelete={handleClick}
      sx={{
        boxShadow: (theme) => theme.shadows[1],
        bgcolor: 'success.light',
        borderColor: 'success.main',
        textTransform: 'none',
        px: 0.5,
        py: 0.5,
        height: 'auto',
        '& .MuiChip-label': {
          display: 'block',
          whiteSpace: 'normal',
        },
        '& .MuiChip-deleteIcon': {
          color: 'success.dark',
        },
      }}
      variant="outlined"
    />
  ) : (
    <Box />
  );
}
